import { render, staticRenderFns } from "./relevancy.vue?vue&type=template&id=a7be2d22&scoped=true&lang=pug"
import script from "./relevancy.vue?vue&type=script&lang=js"
export * from "./relevancy.vue?vue&type=script&lang=js"
import style0 from "./relevancy.vue?vue&type=style&index=0&id=a7be2d22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7be2d22",
  null
  
)

export default component.exports